/* tslint:disable:max-line-length */
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push, replace } from 'redux-router';
import {
  createSpidUser,
  exceptionTypes,
  findUserByEmail,
  findUserByPhoneNumber,
  HideTimeout,
  hideTimeout,
  LogException,
  logException,
  productInfoDeferred,
  userEntersPhoneNumber,
  UserEntersPhoneNumber
} from '../actions/Actions';
import {
  IAddress,
  IProductInfo,
  IReduxRouterAction,
  IReferer,
  IState,
  IUserInfo
} from '../CustomTypes';
import {
  createB64data,
  createDateString,
  getUrlForPage
} from '../fastflowUtils';
import {
  Address,
  BirthDate,
  Button,
  Email,
  LoadUserDataFromUrl,
  MobileNumber,
  Name
} from '../input-components/InputComponents';
import FooterSameLoginAsOthers from '../layout-components/FooterSameLoginAsOthers';
import { sccPulseTrackPageView } from '../PulseUtils';
import {
  validate16yearOld,
  validateCity,
  validateEmail,
  validateName,
  validatePhoneNumber,
  validateZipCode
} from '../validators';
import './UserSearch.scss';
import SchibstedAccountInfo from '../gdpr/ShibstedAccountInfo';
import LegalAge from '../gdpr/LegalAge';

export interface IUserSearchParamProps {
  __rct?: string;
  address: IAddress;
  pathname: string;
  productInfo: IProductInfo;
  referer: IReferer;
  userInfo: IUserInfo;
  showWarning: boolean;
  query: any;
}

export interface IUserSearchActionProps {
  createSpidUser: createSpidUser;
  findUserByEmail: findUserByEmail;
  findUserByPhoneNumber: findUserByPhoneNumber;
  hideTimeout: HideTimeout;
  push: IReduxRouterAction;
  replace: IReduxRouterAction;
  logException: LogException;
  userEntersPhoneNumber: UserEntersPhoneNumber;
}

export interface IUserSearchState {
  formSubmitted: boolean;
  searchModus: SearchModus;
  skipPhoneNumber: boolean;
}

export interface IUserSearchProps
  extends IUserSearchParamProps,
    IUserSearchActionProps {}

export enum SearchModus {
  SEARCH_EMAIL,
  SEARCH_PHONE,
  REGISTER_NEW
}

export class UserSearch extends React.Component<
  IUserSearchProps,
  IUserSearchState
> {
  constructor(props: IUserSearchProps) {
    super(props);
    this.getTitle = this.getTitle.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onSkipPhoneNumber = this.onSkipPhoneNumber.bind(this);
    this.searchForUser = this.searchForUser.bind(this);
    this.createWaitForEmailUri = this.createWaitForEmailUri.bind(this);
    this.pushWaitForCodeOrWaitForUri = this.pushWaitForCodeOrWaitForUri.bind(
      this
    );
    this.isFormValid = this.isFormValid.bind(this);
    this.changeEmailAndPhone = this.changeEmailAndPhone.bind(this);

    this.state = {
      formSubmitted: false,
      searchModus: SearchModus.SEARCH_EMAIL,
      skipPhoneNumber: false
    };
  }

  public componentWillMount() {
    if (
      this.props.query.email &&
      !this.props.query.phoneNumber &&
      this.props.query.dosearch &&
      validateEmail(this.props.query.email)
    ) {
      this.searchForUser();
    }
  }

  public componentDidMount() {
    productInfoDeferred.promise.then(product => {
      sccPulseTrackPageView(product, {}, 'User search');
    });
  }

  public render() {
    const { email, phoneNumber } = this.props.userInfo;
    const { pureDigital, validZipCodes } = this.props.productInfo;
    const { searchModus, formSubmitted } = this.state;
    return (
      <div className="userSearch">
        <LoadUserDataFromUrl />
        <div className="container">
          <h1>{this.getTitle()}</h1>
          <div className="row">
            <form onSubmit={this.onSubmit}>
              <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
                {searchModus === SearchModus.SEARCH_EMAIL && (
                  <Email initialFocus={true} formSubmitted={formSubmitted} />
                )}
                {searchModus === SearchModus.SEARCH_PHONE && (
                  <div className="mobileNumber">
                    <MobileNumber
                      initialFocus={true}
                      formSubmitted={formSubmitted}
                      validationErrorMessage={
                        <div>
                          Kun norske mobilnummer. Har du et utenlandsk nummer{' '}
                          <a
                            href="#"
                            onClick={this.onSkipPhoneNumber}
                            className="underline"
                          >
                            klikk her for å gå videre
                          </a>
                        </div>
                      }
                    />
                  </div>
                )}
                {searchModus === SearchModus.REGISTER_NEW && (
                  <div className="row">
                    <div className="col-xs-12 changeInfo">
                      <textarea
                        disabled={true}
                        rows={2}
                        value={`${email}\n${phoneNumber}`}
                      />
                      <a onClick={this.changeEmailAndPhone}>
                        <span className="glyphicon glyphicon-pencil" /> Endre
                      </a>
                    </div>
                    <div className="col-xs-12">
                      <Name formSubmitted={formSubmitted} initialFocus={true} />
                    </div>
                    <div className="col-xs-12">
                      <BirthDate formSubmitted={formSubmitted} />
                    </div>
                    {searchModus === SearchModus.REGISTER_NEW &&
                      !pureDigital && (
                        <Address
                          formSubmitted={formSubmitted}
                          validZipCodes={validZipCodes}
                        />
                      )}
                  </div>
                )}
              </div>

              <div className="col-xs-12">
                <Button type="submit" disabled={!this.isFormValid()}>
                  {searchModus === SearchModus.REGISTER_NEW
                    ? 'Registrer bruker'
                    : 'Gå videre'}
                </Button>
              </div>
            </form>
          </div>
        </div>
        <FooterSameLoginAsOthers>
          {this.getFooterText()}
        </FooterSameLoginAsOthers>
      </div>
    );
  }

  private getFooterText() {
    switch (this.state.searchModus) {
      default:
      case SearchModus.SEARCH_EMAIL:
      case SearchModus.SEARCH_PHONE:
        return <SchibstedAccountInfo />;
      case SearchModus.REGISTER_NEW:
        return (
          <div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2">
            <LegalAge />
          </div>
        );
    }
  }

  private getTitle(): string {
    switch (this.state.searchModus) {
      case SearchModus.SEARCH_EMAIL:
        return 'Legg til din e-post';
      case SearchModus.SEARCH_PHONE:
        return 'Legg til ditt mobilnummer';
      case SearchModus.REGISTER_NEW:
        return 'Dine opplysninger';
    }
  }

  private onSubmit(e: any) {
    e.preventDefault();

    if (this.props.showWarning) {
      this.props.hideTimeout();
    }

    this.setState({ formSubmitted: true });

    if (!this.isFormValid()) {
      return false;
    }

    const {
      email,
      phoneNumber,
      firstName,
      lastName,
      birthDay,
      birthMonth,
      birthYear
    } = this.props.userInfo;
    const { zipCode } = this.props.address;
    this.props.replace({
      pathname: this.props.pathname,
      query: Object.assign({}, this.props.query, {
        birthDay,
        birthMonth,
        birthYear,
        email: encodeURIComponent(email),
        firstName: encodeURIComponent(firstName),
        lastName: encodeURIComponent(lastName),
        phoneNumber: encodeURIComponent(phoneNumber),
        zipCode
      })
    });

    this.searchForUser();
    this.setState({ formSubmitted: false });
  }

  private isFormValid() {
    const {
      email,
      phoneNumber,
      firstName,
      lastName,
      birthDay,
      birthMonth,
      birthYear
    } = this.props.userInfo;
    const { zipCode, city } = this.props.address;
    const { pureDigital, validZipCodes } = this.props.productInfo;
    if (!validateEmail(email)) {
      return false;
    }
    if (
      this.state.searchModus === SearchModus.SEARCH_PHONE &&
      !this.state.skipPhoneNumber &&
      !validatePhoneNumber(phoneNumber)
    ) {
      return false;
    }

    if (this.state.searchModus === SearchModus.REGISTER_NEW) {
      if (!validate16yearOld(+birthDay, +birthMonth - 1, +birthYear)) {
        return false;
      }

      if (!validateName(firstName) || !validateName(lastName)) {
        return false;
      }

      if (!pureDigital) {
        if (!validateZipCode(zipCode, validZipCodes) || !validateCity(city)) {
          return false;
        }
      }
    }
    return true;
  }

  private searchForUser() {
    const email = this.props.userInfo.email || this.props.query.email;
    const {
      phoneNumber,
      firstName,
      lastName,
      birthDay,
      birthMonth,
      birthYear
    } = this.props.userInfo;
    const { pureDigital, productId } = this.props.productInfo;
    const { referer, redirectUri } = this.props.referer;
    const { searchModus } = this.state;
    const logException = this.props.logException;
    let urlNextStep = pureDigital
      ? getUrlForPage(productId, 'selectpaymentmethod')
      : getUrlForPage(productId, 'userinfolandingpage');
    let urlSelectPaymentMethod = getUrlForPage(
      productId,
      'selectpaymentmethod'
    );
    const b64DataParam = `?b64data=${encodeURIComponent(
      createB64data(
        null,
        this.props.referer,
        phoneNumber,
        searchModus === SearchModus.REGISTER_NEW,
        email
      )
    )}`;
    urlNextStep += b64DataParam;
    urlSelectPaymentMethod += b64DataParam;

    let rctParam = '';
    if (this.props.__rct) {
      rctParam = `&__rct=${this.props.__rct}`;
    }

    if (searchModus === SearchModus.REGISTER_NEW) {
      let returnUrl = urlSelectPaymentMethod;
      // GotoSPid for all temporarily SNOAM-8995
      if (true || this.isSafari12()) {
        returnUrl = getUrlForPage(productId, 'gotospid');
        returnUrl += b64DataParam;
      }

      const birthDateString = createDateString(birthDay, birthMonth, birthYear);

      (this.props.createSpidUser(
        email,
        firstName,
        lastName,
        phoneNumber,
        returnUrl,
        birthDateString,
        this.props.address
      ) as any).then((result: any) => {
        this.props.push(
          this.createWaitForEmailUri(
            result.email,
            result.userCreated,
            result.loginLinkSent,
            false,
            false
          ) + rctParam
        );
      });

      sccPulseTrackPageView(this.props.productInfo, {}, 'User search', {
        emailInput: 'true',
        personaliaInput: 'true',
        phoneInput: 'true'
      });
      return;
    }
    if (searchModus === SearchModus.SEARCH_PHONE) {
      // Find user by phone number
      (this.props.findUserByPhoneNumber(phoneNumber, email, urlNextStep) as any)
        .then((result: any) => {
          this.pushWaitForCodeOrWaitForUri(result);
        })
        .catch((e: any) => {
          logException(exceptionTypes.EXCEPTION, e);
          if (e.status === 409) {
            const emailFromResponse: string = JSON.parse(e.data).email;
            this.props.push(
              this.createGotoSpidUrl(
                productId,
                emailFromResponse,
                referer,
                redirectUri
              ) + rctParam
            );
          } else {
            this.setState({
              searchModus: SearchModus.REGISTER_NEW
            });
          }
        });
      sccPulseTrackPageView(this.props.productInfo, {}, 'User search', {
        emailInput: 'true',
        personaliaInput: 'false',
        phoneInput: 'true'
      });
      return;
    }

    // Find user by email
    (this.props.findUserByEmail(email, urlNextStep) as any)
      .then((result: any) => {
        this.pushWaitForCodeOrWaitForUri(result);
      })
      .catch((e: any) => {
        logException(exceptionTypes.EXCEPTION, e);
        if (e.status === 409) {
          let userEmail = email;
          const emailFromResponse: string = JSON.parse(e.data).email;
          if (!!emailFromResponse) {
            userEmail = emailFromResponse;
          }
          this.props.push(
            this.createGotoSpidUrl(productId, userEmail, referer, redirectUri) +
              rctParam
          );
        } else {
          this.setState({
            searchModus: SearchModus.SEARCH_PHONE
          });
        }
      });
    sccPulseTrackPageView(this.props.productInfo, {}, 'User search', {
      emailInput: 'true',
      personaliaInput: 'false',
      phoneInput: 'false'
    });
  }

  private createGotoSpidUrl(
    productId: string,
    email: string,
    referer: string,
    redirectUri: string
  ): string {
    return `/products/${productId}/gotospid?email=${encodeURIComponent(
      email
    )}&referer=${encodeURIComponent(referer)}&redirect_uri=${encodeURIComponent(
      redirectUri
    )}`;
  }

  private isSafari12(): boolean {
    const userAgent = (navigator && navigator.userAgent) || '';
    if (!userAgent) {
      return false;
    }
    return (
      userAgent.includes('Safari') &&
      !userAgent.includes('Chrome') &&
      userAgent.includes('Version/12.')
    );
  }

  private pushWaitForCodeOrWaitForUri(result: any) {
    const {
      userCreated,
      loginLinkSent,
      sentCodeOnSMS,
      sentCodeOnEmail
    } = result;
    let rctParam = '';
    if (this.props.__rct) {
      rctParam = `&__rct=${this.props.__rct}`;
    }
    if (sentCodeOnSMS || sentCodeOnEmail) {
      const phoneNumberSentTo = encodeURIComponent(result.phone);
      const emailSentTo = encodeURIComponent(result.email);
      const email = encodeURIComponent(this.props.userInfo.email);
      const phoneNumber = encodeURIComponent(this.props.userInfo.phoneNumber);
      const firstName = encodeURIComponent(this.props.userInfo.firstName);
      const lastName = encodeURIComponent(this.props.userInfo.lastName);
      const zipCode = encodeURIComponent(this.props.address.zipCode);
      const birthDay = encodeURIComponent(String(this.props.userInfo.birthDay));
      const birthMonth = encodeURIComponent(
        String(this.props.userInfo.birthMonth)
      );
      const birthYear = encodeURIComponent(
        String(this.props.userInfo.birthYear)
      );
      const referer = encodeURIComponent(this.props.referer.referer);
      const redirectUri = encodeURIComponent(this.props.referer.redirectUri);
      const searchParams = `email=${email}&phoneNumer=${phoneNumber}&firstName=${firstName}&lastName=${lastName}&zipCode=${zipCode}&birthDay=${birthDay}&birthMonth=${birthMonth}&birthYear=${birthYear}`;
      this.props.push(
        `/products/${
          this.props.productInfo.productId
        }/checkcode?hasPhone=${sentCodeOnSMS}&phoneNumberSentTo=${phoneNumberSentTo}&emailSentTo=${emailSentTo}&${searchParams}&referer=${referer}&redirect_uri=${redirectUri}${rctParam}`
      );
      return 'sms';
    } else {
      this.props.push(
        this.createWaitForEmailUri(
          result.email,
          userCreated,
          loginLinkSent,
          result.hasPhone,
          result.hasPaymentMethods
        ) + rctParam
      );
      return 'email';
    }
  }

  private createWaitForEmailUri(
    emailSentTo: string,
    userCreated: boolean,
    loginLinkSent: boolean,
    hasPhone: boolean,
    hasPaymentMethods: boolean
  ) {
    const { referer, redirectUri } = this.props.referer;
    const uriSafeEmailSentTo = encodeURIComponent(emailSentTo);
    return `/products/${
      this.props.productInfo.productId
    }/waitForEmail?emailSentTo=${uriSafeEmailSentTo}&userCreated=${
      userCreated ? userCreated : false
    }&loginLinkSent=${loginLinkSent}&hasPhone=${hasPhone}&hasPaymentMethods=${hasPaymentMethods}&referer=${encodeURIComponent(
      referer
    )}&redirect_uri=${encodeURIComponent(redirectUri)}`;
  }

  private onSkipPhoneNumber() {
    this.props.userEntersPhoneNumber('');
    this.setState({
      searchModus: SearchModus.REGISTER_NEW,
      skipPhoneNumber: true
    });
  }

  private changeEmailAndPhone() {
    this.setState({
      searchModus: SearchModus.SEARCH_EMAIL
    });
  }
}

export default connect(
  (state: IState) =>
    ({
      __rct: state.router.location.query.__rct,
      address: state.address,
      pathname: state.router.location.pathname,
      productInfo: state.productInfo,
      query: state.router.location.query,
      referer: state.referer,
      showWarning: state.timeout.showWarning,
      userInfo: state.userInfo
    } as IUserSearchParamProps),
  dispatch =>
    bindActionCreators(
      {
        createSpidUser,
        findUserByEmail,
        findUserByPhoneNumber,
        hideTimeout,
        logException,
        push,
        replace,
        userEntersPhoneNumber
      },
      dispatch
    ) as IUserSearchActionProps
)(UserSearch);



// WEBPACK FOOTER //
// ./src/page-components/UserSearch.tsx